import React, { FC, ReactNode, useEffect, useState } from 'react';
import Actions from './Actions';
import translate from '@translate';
import { langCodes } from 'src/resources/constantsCodes/constants';
import { Grid } from '@mui/material';
import Select from '../../components/Select';
import TextField from 'src/components/TextField';
import { GridItem } from '../../components/Grid';
import { useSelector } from 'react-redux';
import { RootStoreType } from '../../types/store';

export interface TemplateFormProps {
    templateDataStructureCodes: any;
    data: any;
    templateDataStructureCodesObject: any;
    newEmailTemplate: any;
    saveTemplate: any;
    deleteTemplate: any;
    duplicateTemplate: any;
    changeValue: any;
    disableEdit: boolean;
    errors: any;
}

const TemplateForm: FC<TemplateFormProps> = (props) => {
    const [testExample, setTestExample] = useState('');
    const templateDataStructureCodes = useSelector(
        (state: RootStoreType) => state.constantsCodes.data.templateDataStructureCodes
    );
    const templateDataStructureCodesObject = templateDataStructureCodes.reduce((obj, item) => {
        return {
            ...obj,
            // @ts-ignore
            [item['value']]: item,
        };
    }, {});
    useEffect(() => {
        // @ts-ignore
        if (props.data.TYPE && templateDataStructureCodesObject[props.data.TYPE]) {
            setTestExample(
                // @ts-ignore
                JSON.stringify(JSON.parse(templateDataStructureCodesObject[props.data.TYPE].json), null, '\t')
            );
        }
    }, [props.data?.TYPE]);

    return (
        <Grid>
            <GridItem cols={12}>
                <Actions
                    disableEdit={props.disableEdit}
                    newEmailTemplate={props.newEmailTemplate}
                    saveTemplate={props.saveTemplate}
                    duplicateTemplate={props.duplicateTemplate}
                    deleteTemplate={props.deleteTemplate}
                />
            </GridItem>
            <GridItem cols={12}>
                <TextField
                    label={translate('emailTemplateDetail.name')}
                    value={props.data.NAME}
                    onChange={(value: any, error: boolean): any => props.changeValue( 'NAME', value, error)}
                    name="NAME"
                    error={props.errors.NAME}
                    disabled={props.disableEdit}
                    required
                    fullWidth
                />
            </GridItem>
            <GridItem cols={12}>
                <Select
                    label={translate('emailTemplateDetail.lang')}
                    value={props.data.LANG}
                    options={langCodes}
                    onChange={(value: any, error: boolean): any => props.changeValue('LANG', value, error)}
                    name="LANG"
                    error={props.errors.LANG}
                    disabled={props.disableEdit}
                    required
                    fullWidth
                />
            </GridItem>
            <GridItem cols={12}>
                <Select
                    label={translate('emailTemplateDetail.type')}
                    value={props.data.TYPE}
                    onChange={(value: any, error: boolean): any => props.changeValue('TYPE', value, error)}
                    options={templateDataStructureCodes}
                    name="TYPE"
                    error={props.errors.TYPE}
                    disabled={props.disableEdit}
                    required
                    fullWidth
                />
            </GridItem>
            <GridItem cols={12}>
                <TextField
                    multiline
                    label={translate('emailTemplateDetail.testExample')}
                    value={testExample}
                    disabled
                    fullWidth
                />
            </GridItem>
        </Grid>
    );
};

export default TemplateForm;
